import { Injectable } from '@angular/core';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { environment } from '../../../environments/environment';
import {BdbRequestService} from './bdb-request.service';
import { RequestInfo } from '../models/request-info.model';
import HttpStatusCode from '../enums/http-status.enum';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';

@Injectable()
export class BdbOlimpiaService {

    constructor(
        private readonly bdbSessionStrgService: BdbSessionStrgService,
        private readonly bdbRequest: BdbRequestService
    ) {
    }

    public inquiryFaceInOlimpia(image?: string) {
        const url = environment.olimpiaEndpoint + '/validate-identity';
        const identityType = this.bdbSessionStrgService.get('identityType');
        const identityNumber = this.bdbSessionStrgService.get('identityNumber');
        const body = this.getCompareFacesBody(image);
        return new Promise<any>((resolve, reject) => {
            fetch(url, {
                headers: this.getCommonHeaders(identityType, identityNumber),
                body: JSON.stringify(body),
                method: 'POST'
            }).then(async (res) => {
                const response = await res.json();
                this.bdbSessionStrgService.save('provider', response.provider);
                resolve(response);
            }).catch((reason) => {
                console.log(reason);
                reject(reason);
            })
        })
    }

    private getCommonHeaders(identityType: string, identityNumber: string) {
        return {
            'content-type': 'application/json',
            'X-GovIssueIdentType': identityType,
            'X-IdentSerialNum': identityNumber,
            'X-Channel': this.bdbSessionStrgService.get(SessionStorageKeysEnum.MEDIUM_TYPE),
            'X-IPAddr': this.bdbSessionStrgService.get(SessionStorageKeysEnum.PUBLIC_IP),
            'X-Product': this.bdbSessionStrgService.get(SessionStorageKeysEnum.SITE),
            'X-Auth-Token': this.bdbSessionStrgService.get('uuidAuth'),
            'X-UuidAuth': this.bdbSessionStrgService.get('uuidAuth')
        }
    }

    public inquirySelfieInOlimpia() {
        const url = environment.olimpiaEndpoint + '/compare-faces';
        const identityType = this.bdbSessionStrgService.get('identityType');
        const identityNumber = this.bdbSessionStrgService.get('identityNumber');
        return new Promise<any>((resolve, reject) => {
            fetch(url, {
                headers: this.getCommonHeaders(identityType, identityNumber),
                body: JSON.stringify({
                    targetFileName: this.bdbSessionStrgService.get('targetFileName'),
                    reportData: this.getReportDataCompareFaces(),
                    provider: this.bdbSessionStrgService.get('provider'),
                    imageRoute: this.bdbSessionStrgService.get('routeFileName')
                }),
                method: 'POST'
            }).then(async (res) => {
                const response = await res.json();
                if (res.status === 200) {
                    resolve(response);
                } else {
                    reject(response)
                }
            }).catch((reason) => {
                reject(reason);
            })
        })
    }

    public compareFacesService(image?: string) {
        const url = environment.olimpiaEndpointSanbox + '/compare-faces';
        const identityType = this.bdbSessionStrgService.get('identityType');
        const identityNumber = this.bdbSessionStrgService.get('identityNumber');
        const body = this.getCompareFacesBody(image);
        const uuidAuth = this.bdbSessionStrgService.get('uuidAuth');
        const httpHeaders = this.getCommonHeaders(identityType, identityNumber);
        const info: RequestInfo = {headers: httpHeaders, body};
        return new Promise<any>((resolve, reject) => {
            this.bdbRequest.requestPostSandboxHeadersWithoutNewHeaders(url, uuidAuth, info)
                .then((res) => {
                    const response = JSON.parse(res.body);
                    if (res.status === HttpStatusCode.NON_AUTHORITATIVE_INFORMATION) {
                        resolve({
                            status: HttpStatusCode.NON_AUTHORITATIVE_INFORMATION,
                            response
                        });
                    } else if (res.status === 401) {
                        reject({
                            status: 401,
                            response
                        });
                    } else {
                        reject(response);
                    }
                }).catch((reason) => {
                reject(reason);
            });
        });
    }

    getSellerUsername(mediumType: string): string {
        if (mediumType === '3') {
            return this.bdbSessionStrgService.get('sellerUsername');
        } else if (mediumType === '1') {
            return 'AlliedForLivenessAndRecognition'
        } else {
            return '';
        }
    }

    getSellerIdNumberLdap(mediumType: string): string {
        if (mediumType === '3') {
            return this.bdbSessionStrgService.get('sellerIdentityNumberLdap');
        } else if (mediumType === '1') {
            return 'AlliedForLivenessAndRecognition'
        } else {
            return '';
        }
    }
    private getReportDataCompareFaces() {
        return {
            specificProductInfoUuid: this.bdbSessionStrgService.get(SessionStorageKeysEnum.SPECIFIC_PRODUCT_INFO_UUID),
            uuidAuth: this.bdbSessionStrgService.get('uuidAuth')
        };
    }
    private getCompareFacesBody(image?: string) {
        if (typeof (image) !== 'undefined') {
            return {
                //image: this.recognitionService.compressImageBase64(image),
                reportData: this.getReportDataCompareFaces()
            };
        } else {
            return {
                provider: this.bdbSessionStrgService.get('provider'),
                targetFileName: this.bdbSessionStrgService.get('targetFileName'),
                reportData: this.getReportDataCompareFaces(),
                routeFileName: this.bdbSessionStrgService.get('routeFileName')
            };
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/bdb-olimpia.service.ts